module.exports = __webpack_public_path__ + "img/logo2.2597d9d7.png";